import {
  backButton,
  viewport,
  themeParams,
  miniApp,
  initData,
  configure
} from '@telegram-apps/sdk-react'

export function init(debug: boolean): void {
  // Настройка SDK
  configure()

  if (!backButton.isSupported() || !miniApp.isSupported()) {
    throw new Error('ERR_NOT_SUPPORTED')
  }

  backButton.mount()
  miniApp.mount()
  themeParams.mount()
  initData.restore()
  void viewport
    .mount()
    .catch(e => {
      console.error('Something went wrong mounting the viewport', e)
    })
    .then(() => {
      viewport.bindCssVars()
    })

  miniApp.bindCssVars()
  themeParams.bindCssVars()
}
